import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Container } from '@/components/ui/container';
import { Logo } from '@/components/brand/logo';
import { cn, focusRing } from '@/lib/utils';

const FOOTER_LINKS = [
  { to: '/services', label: 'Services' },
  { to: '/outcome-plan', label: 'Outcome plan' },
  { to: '/privacy', label: 'Privacy' },
] as const;

const CONTACT_EMAIL = 'hello@humaine.co.za';

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-24 border-t border-border/60 bg-bg">
      <Container size="xl" className="py-12">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between">
          <div className="max-w-sm">
            <Link
              to="/"
              aria-label="HumAIne home"
              className={cn('inline-flex rounded-md', focusRing)}
            >
              <Logo />
            </Link>
            <p className="mt-3 text-sm leading-relaxed text-fg-muted">
              Practical AI consulting that turns ideas into outcomes you can defend on a board
              slide.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-3">
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-wider text-fg-muted">
                Explore
              </h2>
              <ul className="mt-4 space-y-2">
                {FOOTER_LINKS.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className={cn('text-sm text-fg-muted hover:text-fg', 'rounded-sm', focusRing)}
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h2 className="text-xs font-semibold uppercase tracking-wider text-fg-muted">
                Contact
              </h2>
              <ul className="mt-4 space-y-2">
                <li>
                  <a
                    href={`mailto:${CONTACT_EMAIL}`}
                    className={cn(
                      'inline-flex items-center gap-2 text-sm text-fg-muted hover:text-fg',
                      'rounded-sm',
                      focusRing,
                    )}
                  >
                    <Mail aria-hidden="true" className="size-4" />
                    {CONTACT_EMAIL}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-border/60 pt-6 text-xs text-fg-muted sm:flex-row sm:items-center sm:justify-between">
          <p>&copy; {year} HumAIne. All rights reserved.</p>
          <p>South Africa &middot; Remote-first</p>
        </div>
      </Container>
    </footer>
  );
}
